"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _set2 = _interopRequireDefault(require("lodash/set"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var setInitialFieldValues = function setInitialFieldValues(fieldConfig, fieldValues) {
  return Object.keys(fieldValues).filter(function (key) {
    return Boolean(fieldValues[key]);
  }).reduce(function (accum, key) {
    (0, _set2["default"])(accum[key], 'input.value', fieldValues[key]);
    return accum;
  }, fieldConfig);
};
var _default = exports["default"] = setInitialFieldValues;